<template>
  <button
    :disabled="disabled"
    :title="buttonTitle"
    @click="shouldAnimate ? (animated = true) : null"
    @animationend="animated = false"
    :class="animated ? 'animate' : ''"
    :style="[
      icon !== ''
        ? {
            color: color,
            border,
            backgroundColor: bgcolor,
            fontSize: fontSize + 'px',
            height: height + 'px',
            width: width,
            margin,
            padding,
            verticalAlign: valign,
            backgroundImage: `url(${require(`@/assets/icons/${icon}.svg`)})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: '100%',
            boxShadow: shadow ? '2px 2px 8px 0 rgba(0, 0, 0, 0.07)' : ''
          }
        : {
            color: disabled ? '#b5b5b5' : color,
            pointer: disabled ? 'not-allowed' : 'pointer',
            border: disabled ? 'solid  #b5b5b5' :border ,
            backgroundColor: disabled ? '#FFFFFF' : bgcolor,
            fontSize: fontSize + 'px',
            height: height + 'px',
            width: width,
            margin,
            padding,
            verticalAlign: valign,
            boxShadow: shadow ? '2px 2px 8px 0 rgba(0, 0, 0, 0.07)' : ''
          }
    ]"
  >
    {{ title }}
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    title: {},
    disabled: {default: false},
    buttonTitle: {},
    color: { default: "#fff" },
    fontSize: { default: 14 },
    bgcolor: { default: "#00a9b3" },
    height: { default: 30 },
    width: { default: "auto" },
    margin: { default: "0" },
    padding: { default: "0 2rem" },
    icon: { default: "" },
    shouldAnimate: { default: false },
    shadow: { default: false },
    valign: { default: "middle" },
    border: { default: "none" }
  },
  data: function() {
    return {
      animated: false
    };
  }
};
</script>

<style scoped>
button {
  cursor: pointer;
  border-radius: 50px;
  min-width: 30px;
}

button.animate {
  animation: expansion 0.5s normal ease;
}

button:hover {
  opacity: 0.95;
}

@keyframes expansion {
  0% {
    transform: scale(1, 1);
  }
  30% {
    transform: scale(0.8, 0.8);
  }
  80% {
    transform: scale(1.5, 1.5);
  }
  100% {
    transform: scale(1, 1);
  }
}
</style>
